import moment from "moment";

const dogumTarihi = (value, message) => {
  if (!value) {
    return null;
  }

  const today = moment().startOf("day");
  const date = moment(value, "DD/MM/YYYY", true);

  if (date.startOf("day").isAfter(today))
    return "Girilen tarih bugünden büyük olamaz.";

  if (!date.isValid()) {
    return message ?? "Doğum tarihinizi kontrol edin.";
  }

  return null;
};

export default dogumTarihi;
